import { PrintResult } from "../../interfaces/print";
import { getUrlFromBlob } from "../../utils/image";

export const printResultToImage = ({ image, format, name }: PrintResult) => ({
  src: getUrlFromBlob(image),
  fileName: `${name}.${format}`,
});
